export const getVideo = (videos, videoId) => videos.find(video => video._id ===  videoId);